import { render, staticRenderFns } from "./Purpose.vue?vue&type=template&id=0d67af75&scoped=true&"
import script from "./Purpose.vue?vue&type=script&lang=js&"
export * from "./Purpose.vue?vue&type=script&lang=js&"
import style0 from "./Purpose.vue?vue&type=style&index=0&id=0d67af75&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d67af75",
  null
  
)

export default component.exports